import * as React from 'react';

import EmployeeReview56 from './EmployeeReview56';

export const employeeReview56 = () => <EmployeeReview56 />;

export default {
    title: 'Illustration|EmployeeReview56',
    component: EmployeeReview56,
    parameters: {
        notes: "`import EmployeeReview56 from 'box-ui-elements/es/illustration/EmployeeReview56';`",
    },
};
